import React from 'react';
import PricesTab from './Tabs';

function Prices() {
    return <PricesTab />;
}

export default React.memo(Prices);
